import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@app/components/ui/dropdown-menu';
import { UserInfo } from '@app/components/user-info';
import { useMobileNavigation } from '@app/hooks/use-mobile-navigation';
import { type User } from '@app/types';
import { AnyLink } from '@app/components/app-link';
import { KeyRound, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@modules/auth/hooks/context/AuthContext';

interface UserMenuContentProps {
    user: User;
}

export function UserMenuContent({ user }: UserMenuContentProps) {
    const { t } = useTranslation();
    const cleanup = useMobileNavigation();
    const { logout } = useAuth();

    const handleLogout = () => {
        cleanup();
        void logout();
    };

    return (
        <>
            <DropdownMenuLabel className="p-0 font-normal">
                <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                    <UserInfo user={user} showEmail={true} />
                </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
                <AnyLink href="/auth/passkeys" onClick={cleanup}>
                    <KeyRound className="mr-2" />
                    {t('auth.ui.passkey.menuLabel')}
                </AnyLink>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
                <LogOut className="mr-2" />
                {t('common.buttons.logout', { defaultValue: 'Logout' })}
            </DropdownMenuItem>
        </>
    );
}
